export default __webpack_public_path__ + "static/media/edit.cc265d49.svg";